import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/customer/AVersion/index",{
        params: {
            page:params
        }
    } )
}

function SUBMIT_ADD(params) {
    return  axios.post("/customer/AVersion/addPost",{...params} )
}
function LIST_ORDER(params) {
    return  axios.post("/customer/AVersion/listOrder",{list_orders:params} )
}
function EDIT_DATA(params) {
    return  axios.get("/customer/AVersion/edit",{
        params: {
           id:params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/customer/AVersion/editPost",{...params} )
}
function CHANG_STATUS (params) {
    return  axios.post("/customer/AVersion/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/customer/AVersion/delete",{
        params: {
            ids:params
        }
    } )
}
function GET_JURISDICTION(params) {
    return  axios.get("/customer/AVersion/authorize",{
        params: {
            id:params
        }
    } )
}
function SUBMIT_JURISDICTION(params) {
    return  axios.post("/customer/AVersion/authorizePost",{...params}  )
}


export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    GET_JURISDICTION,
    SUBMIT_JURISDICTION,LIST_ORDER
};